import { useState } from "react";
import { ChevronDown, Eye, AlertTriangle, Loader2 } from "lucide-react";
import { KindIcon } from "@/components/Badges";
import { SourceViewer } from "@/components/SourceViewer";
import { t } from "@/i18n";

function SourceRow({ s, onView }) {
  const [open, setOpen] = useState(false);
  return (
    <div className="py-3 border-b border-[var(--border-color)] last:border-0" data-testid={`source-row-${s.label}`}>
      <div className="flex items-center gap-2">
        <span className="chip chip-accent">{s.label}</span>
        <KindIcon kind={s.media_kind || s.kind} />
        <span className="text-sm flex-1 truncate" title={s.filename}>{s.filename}</span>
        {s.status === "processing" && <Loader2 size={14} className="animate-spin faint" />}
        {s.quality === "low" && <span className="chip chip-warn" title={(s.issues || []).join("; ")}>{t("Low quality")}</span>}
      </div>
      {(s.issues || []).length > 0 && (
        <p className={`text-xs mt-1 flex gap-1 ${s.quality === "low" ? "text-[var(--status-warning)]" : "faint"}`}>
          {s.quality === "low" && <AlertTriangle size={12} className="mt-0.5" />}{s.issues.join("; ")}
        </p>
      )}
      <div className="flex gap-2 mt-2">
        <button className="btn btn-ghost btn-sm" onClick={() => onView(s)} data-testid={`source-view-button-${s.label}`}><Eye size={13} /> {t("Original")}</button>
        <button className="btn btn-ghost btn-sm" onClick={() => setOpen(!open)} data-testid={`source-extract-toggle-${s.label}`}>{t("Extracted")} <ChevronDown size={13} className={open ? "rotate-180" : ""} /></button>
      </div>
      {open && <pre className="whitespace-pre-wrap text-xs muted mt-2 max-h-60 overflow-auto bg-[var(--bg-primary)] p-3 rounded" data-testid={`source-extract-${s.label}`}>{s.extracted_text || t("(nothing extracted)")}</pre>}
    </div>
  );
}

export function SourcesPanel({ sources = [] }) {
  const [viewing, setViewing] = useState(null);
  return (
    <div className="card" data-testid="sources-panel">
      <p className="mono-label mb-1">{t("Source media / references")}</p>
      <p className="text-xs faint mb-2">{t("Originals are preserved exactly as captured.")}</p>
      {sources.map((s) => <SourceRow key={s.id} s={s} onView={setViewing} />)}
      <SourceViewer source={viewing} onClose={() => setViewing(null)} />
    </div>
  );
}
